import { z } from 'zod';

export const documentSourceTypeSchema = z
  .object({
    id: z.number().int(),
    name: z.string(),
    description: z.string().nullable().optional(),
  })
  .transform((raw) => ({
    key: String(raw.id),
    systemName: raw.name,
    value: raw.name,
  }));

export type DocumentSourceTypeOption = z.output<typeof documentSourceTypeSchema>;
export type DocumentSourceTypeApi = z.input<typeof documentSourceTypeSchema>;
